import type { Ref } from 'vue'
import { ApiErrorException } from '@/types/apiErrors'
import type { ApiError } from '@/types/apiErrors'

export interface ApiErrorAdapter {
  getMessage(): string
  getStatus(): number | undefined
  getErrors(): ApiError[]
  /** Primeiro errors[].code (formato Corp). */
  getPrimaryErrorCode(): string | undefined
  isValidationError(): boolean
  getFieldErrors(): Record<string, string[]>
}

export function useApiError(caught: unknown): ApiErrorAdapter {
  if (caught instanceof ApiErrorException) {
    return caught
  }
  return {
    getMessage(): string {
      return caught instanceof Error ? caught.message : 'Erro inesperado'
    },
    getStatus(): undefined {
      return undefined
    },
    getErrors(): ApiError[] {
      return []
    },
    getPrimaryErrorCode(): undefined {
      return undefined
    },
    isValidationError(): boolean {
      return false
    },
    getFieldErrors(): Record<string, string[]> {
      return {}
    },
  }
}

/**
 * Atualiza error e fieldErrors da store a partir de um caught, com fallback opcional.
 * Fallback só é usado quando o erro é unknown (não Error nem ApiErrorException).
 */
export function setStoreErrorFromCaught(
  errorRef: Ref<string | null>,
  fieldErrorsRef: Ref<Record<string, string[]>>,
  e: unknown,
  fallbackMessage?: string
): void {
  const err = useApiError(e)
  const msg = err.getMessage()
  errorRef.value = msg === 'Erro inesperado' && fallbackMessage !== undefined ? fallbackMessage : msg
  fieldErrorsRef.value = err.getFieldErrors()
}
